import K8MCluster from '@/components/K8M/Cluster/K8MCluster.vue';
import K8MClusterOverview from '@/components/K8M/Cluster/K8MClusterOverview.vue';
import K8MOverviewTable from '@/components/K8M/K8MOverviewTable.vue';
import K8M from '@/views/K8M/K8M.vue';
import K8MDetails from '@/components/K8M/K8Details.vue';
import K8MNodes from '@/components/K8M/Node/K8MNodes.vue';
import K8MDeployments from '@/components/K8M/Deployment/K8MDeployments.vue';
import K8MStatefulsets from '@/components/K8M/Statefulset/K8MStatefulsets.vue';
import K8MDaemonsets from '@/components/K8M/Daemonset/K8MDaemonsets.vue';
import K8MPods from '@/components/K8M/Pod/K8MPods.vue';
import K8MPodDetails from '@/components/K8M/Pod/K8MPodDetails.vue';

export const k8mRoutes = {
  path: 'k8m',
  name: 'k8m',
  component: K8M,
  redirect: {
    name: 'k8mCluster',
  },
  children: [
    {
      name: 'k8mCluster',
      path: 'cluster',
      component: K8MCluster, //TODO: to change
      redirect: {
        name: 'k8mClusterOverview',
      },
      children: [
        {
          name: 'k8mClusterOverview',
          path: '',
          meta: {
            tab: 'cluster',
          },
          component: K8MClusterOverview,
        },
        {
          name: 'k8mNodes',
          path: 'nodes',
          component: K8MNodes,
          redirect: {
            name: 'k8mNodesTable',
          },
          children: [
            {
              name: 'k8mNodesTable',
              path: '',
              meta: {
                tab: 'nodes',
              },
              component: K8MOverviewTable,
            },
          ],
        },
        {
          name: 'k8mNamespacesTable',
          path: 'namespaces',
          meta: {
            tab: 'namespaces',
          },
          component: K8MOverviewTable,
        },
        {
          name: 'k8mDeployements',
          path: 'deployments',
          redirect: {
            name: 'k8mDeployementsTable',
          },
          component: K8MDeployments,
          children: [
            {
              name: 'k8mDeployementsTable',
              path: '',
              meta: {
                tab: 'deployments',
              },
              component: K8MOverviewTable,
            },
          ],
        },
        {
          name: 'k8mStatefulsets',
          path: 'statefulsets',
          redirect: {
            name: 'k8mStatefulsetsTable',
          },
          component: K8MStatefulsets,
          children: [
            {
              name: 'k8mStatefulsetsTable',
              path: '',
              meta: {
                tab: 'statefulsets',
              },
              component: K8MOverviewTable,
            },
          ],
        },
        {
          name: 'k8mDaemonsets',
          path: 'daemonsets',
          redirect: {
            name: 'k8mDaemonsetsTable',
          },
          component: K8MDaemonsets,
          children: [
            {
              name: 'k8mDaemonsetsTable',
              path: '',
              meta: {
                tab: 'daemonsets',
              },
              component: K8MOverviewTable,
            },
          ],
        },
        {
          name: 'k8mPods',
          path: 'pods',
          redirect: {
            name: 'k8mPodsTable',
          },
          component: K8MPods,
          children: [
            {
              name: 'k8mPodsTable',
              path: '',
              meta: {
                tab: 'pods',
              },
              component: K8MOverviewTable,
            },
          ],
        },
      ],
    },
    {
      // This opens up the child components
      name: 'k8mDetails',
      path: 'details',
      component: K8MDetails, //TODO: to change
    },
    {
      // This opens up the child components
      name: 'k8mPodDetails',
      path: 'podDetails',
      component: K8MPodDetails, //TODO: to change
    },
  ],
};
